import { SharedInputEdit } from '../../components/SharedInputEdit';
import { useContext } from 'react';
import { CalculatorAdvancedModeContext } from '../../../../shared/contexts/CalculatorContext';
import { CalculatorAdvancedMode } from '../../../../shared/classes/CalculatorMode';

export function WorkforceInput(): JSX.Element {
    const advancedMode = useContext(CalculatorAdvancedModeContext)!;

    return (
        <div className="workforce --ctow">

            <div>

                <div>

                    <h4>Data Inputs from Customer</h4>

                    <SharedInputEdit inputName='R8_#_of_radiologist'/>
                    <SharedInputEdit inputName='R10_#_of_radiographer'/>
                    {/*<SharedInputEdit inputName='inHouse_engineer_cost'/>*/}

                    <SharedInputEdit inputName='AA10_radiographerwages_per_hour'/>
                    <SharedInputEdit inputName='AA12_radiologistwages_per_hour'/>
                    <SharedInputEdit inputName='AA14_doctor_wages_per_hour'/>
                    <SharedInputEdit inputName='AA17_radiographer_overtime_wages_in_per'/>
                    <SharedInputEdit inputName='AA19_radiologist_overtime_wages_in_per'/>

                </div>

                {
                    advancedMode[0] === CalculatorAdvancedMode.Advanced
                        ? <div>

                            <h4>Data Inputs for Hospital Workflow</h4>

                            <SharedInputEdit inputName='K35_#_of_doctor_clinician'/>
                            <SharedInputEdit inputName='K37_doctor_clinician_wages_per_hours'/>
                            <SharedInputEdit inputName='K39_#_of_nurses'/>
                            <SharedInputEdit inputName='K41_nurses_wages_per_hour'/>

                            <h4>Data Inputs for Surgery Dpt Impact</h4>

                            <SharedInputEdit inputName='V29_#_of_surgeon'/>
                            <SharedInputEdit inputName='V31_surgeon_avg_wages_per_hour'/>
                            <SharedInputEdit inputName='V33_#_of_doctor_clinician'/>
                            <SharedInputEdit inputName='V35_doctor_clinician_avg_wages_per_hour'/>
                            <SharedInputEdit inputName='V37_#_of_nurses'/>
                            <SharedInputEdit inputName='V39_nurses_wages_per_hour'/>
                            <SharedInputEdit inputName='V45_avg_cost_per_hour_in_the_intensive_care_dept'/>

                        </div>

                        : ''
                }

            </div>

        </div>

    );
}
